import React, { useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { Context } from '../../contexts/Context'
import { getCookie } from '../../services/form/cookies'

export default function PrivateRoute ({ children }) {
  const { token, handleToken } = useContext(Context)
  const localToken = getCookie('fmtaccount')
  useEffect(() => {
    if (!token && localToken) {
      handleToken(localToken)
    }
    // eslint-disable-next-line
  }, [localToken])

  if (token || localToken) return children
  if (!token) {
    return <Navigate to='/login' />
  }
  return children
}
